module.exports = __webpack_public_path__ + "img/search-title.8f103940.svg";